

/* CF7 Form redirect */
document.addEventListener( 'wpcf7mailsent', function( event ) {
    location = 'https://nalaandfriends.co.uk/thank-you/';
}, false );


/* radiobuttons */
$(document).on('change', '.__radiobuttons input', function(){
    if ($(this).is(':checked')) {
        $(this).closest('.__radiobuttons').find('.input_wrap > label').removeClass('__checked')
        $(this).parent().addClass('__checked');
    }
});
$('.__radiobuttons input:checked').parent().addClass('__checked');


/* newsletter */
$(function(){
    var toggle = $('.newsletter-form .wpcf7-list-item > label');
    toggle.on('change', function(){
        $(this).toggleClass('__checked');
    });
});

$(function(){

    var empty_item = $('.woof_list input:disabled').css({ 'background' : 'red' });
    empty_item.parent('li').hide();

});


/* tabpanel */
$(function(){
    var tab = $('.tabpanel-tab');
    var panel = $('.tabpanel-panel');

    tab.eq(0).addClass('__active');
    panel.eq(0).addClass('__active');

    tab.click(function(event){
        event.preventDefault();
        tab.removeClass('__active');
        $(this).addClass('__active');
        var data_set = $(this).data('set');
        panel.removeClass('__active');
        panel.filter('[data-set="' + data_set + '"]').addClass('__active');
    });
});


/* accordion */
$(function(){
    var accordion = $('.accordion');
    var title = accordion.find('.accordion-head');
    var content = accordion.find('.accordion-content');

    title.click(function(event){
        event.preventDefault();

        if ($(this).attr('aria-expanded') === 'true') {
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).attr('aria-expanded', 'true');
        }

        $(this).parents('.accordion').toggleClass('__active');
        $(this).siblings().slideToggle();
    });
});


/* modal */
$(function(){
    var trigger = $('.ModalTrigger');
    var modal = $('.modalblock');
    var close = modal.find('.modalblock-close');

    trigger.click(function(event){
        event.preventDefault();
        var modal_id = $(this).data('modal')
        modal.filter('[data-modal="' + modal_id + '"]').addClass('__active');
    });

    close.click(function(){
        modal.removeClass('__active');
    });

    $(window).click(function(event){
        if(event.target.className == "modalblock __active"){
            modal.removeClass('__active');
        }
    });

    $(document).keyup(function(e) {
        if (e.keyCode == 27) {
            $('.modablock.__active').removeClass('__active');
        }
    });
});


/* searchtoggle */
$(function(){
    var search_toggle = $('.searchtoggle');
    var wrapper = $('.wrapper');

    search_toggle.click(function(event){
        event.preventDefault();
        $(this).toggleClass('__active');
        wrapper.toggleClass('__searchactive');
    });
});

/* Main Menu */
$(function(){

    var body =  $('html, body');
    var nav = $('.nav');
    var burger =  $('.burger');
    var nav_trigger =  $('.nav').find('ul li');
    var nav_align = 'right';
    var break_point =  992;
    var browser_width = window.innerWidth;
    var nav_width = 300;
    var nav_window = $('<div class="navwindow"></div>');
    body.append(nav_window);
    var nav_wrap = $('.navwrap');


    nav_window.click(function(event){
        nav_reset();
    });

    //burger click
    burger.click(function(event){
        event.preventDefault();
        $(this).toggleClass('__active');
        if(body.hasClass('__mobile')){
            nav_reset();
        }else{
            nav_launch();
        };
    });

    /*nav reset*/
    var nav_reset = function nav_reset(){
        burger.removeClass('__active');
        nav_window.hide();
        body.removeClass('__mobile');
        nav_wrap.removeClass('__active');
        nav_wrap.find('ul').removeClass('__active');
    };

    /*nav launch*/
    var nav_launch = function nav_launch(){
        nav_window.show();
        // $('html, body').addClass('__mobile');
        body.addClass('__mobile');
        nav_wrap.addClass('__active');
    };

    if(browser_width < break_point){
        nav_trigger.click(function(event){
            event.stopPropagation();
            if($(this).children('ul').length > 0){
                event.preventDefault();
                $(this).parents('ul').removeClass('__active');
                $(this).children('ul').addClass('__active');
            };
        });
    };

    var nav_ul = $('.nav ul li > ul');
    var view_button = $('<li class="viewall"><a href="#">View</a></li>');
    var back_button = $('<li class="backto"><a href="#">Back</a></li>');

    if(browser_width < break_point){
        nav_ul.prepend(view_button);
        nav_ul.prepend(back_button);
    };

    var back_menu = $('.backto');
    back_menu.click(function(event){
        event.preventDefault();
        event.stopPropagation();
        $(this).parent('ul').removeClass('__active');
        $(this).parents('li').parent('ul').addClass('__active');
    });

    var view_all = $('.viewall');
    view_all.each(function(){
        var parent_url = $(this).closest('ul').siblings().attr('href');
        var parent_title = $(this).closest('ul').siblings().html();
        $(this).find('a').attr('href', parent_url);
        $(this).find('a').html('View ' + parent_title);
    });

    view_all.click(function(event){
        event.stopPropagation();
    });

});


/* sidemenu */
$(function(){
    var toggle = $('.sidemenu-toggle');
    toggle.click(function(event){
        event.preventDefault();
        $(this).parent().toggleClass('__active');
        $(this).siblings().slideToggle();
    });
});


/* ScrollTo */
(function(){
    $.fn.scrollto = function(options) {
        var settings = $.extend({
            trigger: '#ScrollTo',
            scroll_to: '.wrapper',
            speed: 1000,
        }, options);
        $(settings.trigger).click(function(event) {
            event.preventDefault();
            $('html, body').animate({
                scrollTop: $(settings.scroll_to).offset().top,
            }, settings.speed);
        });
    }
})();
$('#ScrollTo').scrollto({
    trigger: '#ScrollTo',
    scroll_to: '.wrapper',
    speed: 1000,
});


/*share*/
$(function(){
    // var share_toggle = $('.shareitem-trigger');
    var share_toggle = $('.shareitem');
    share_toggle.hover(function(){
        $(this).find('.shareitem-icons').toggleClass('__active');
      },function() {
        $(this).find('.shareitem-icons').removeClass('__active');
      }
    );
});


/* share social */
$(function(){

    var toggle = $('.socialshare-title');
    var shareicons = $('.socialshare-socialset');

    toggle.click(function(event){
        event.preventDefault();
        $(this).siblings('.socialshare-socialset').toggleClass('__active');
    });

});


/* scroll effects */
$(function(){

    var breakpoint = $('#breakpoint').offset().top;
    var animate_target = $('.AnimateTarget');
    var animate_img = $('.AnimateImg');
    var animate_imgwrap = '<div class="AnimateImgWrap __imgreveal"></div>';
    animate_img.wrap(animate_imgwrap)

    animate_img.each(function(){
        var animate_img_height = $(this).height();
        animate_img_item = $(this).parent($('.AnimateImgWrap'));
        animate_img_item.height(animate_img_height);
    });

    animate_img_item = $('.AnimateImgWrap');

    var fadeinandting = function fadeinandting(){
        animate_target.each(function(){
            var scrollTop = $(window).scrollTop();
            var targetfromtop = $(this).offset().top;
            var targetdistancetotop = targetfromtop - scrollTop;

            if(targetdistancetotop <= breakpoint){
                $(this).removeClass('__Ytotop');
                $(this).removeClass('__lefttocenter');
                $(this).removeClass('__righttocenter');
                $(this).removeClass('__listanimate');
                $(this).removeClass('__scale0to1');
                $(this).removeClass('__flip');
            }
        });
        if($('.AnimateImgWrap').length > 0){
            animate_img_item.each(function(){
                var scrollTop = $(window).scrollTop();
                var targetfromtop = $(this).offset().top;
                var targetdistancetotop = targetfromtop - scrollTop;

                if(targetdistancetotop <= breakpoint){
                    $(this).removeClass('__imgreveal');
                }
            });
        }else{
            // console.log('doesnt exist');
        }
    };


    $(window).on('scroll', function () {
        fadeinandting();
    });
    fadeinandting();

});



/* Product Filter toggle */
$(function(){

    var browser_width = window.innerWidth;
    var toggle = $('.productfilter__toggle');
    var form = $('.productfilter__form');

    toggle.click(function(){
        console.log('click');
        $(this).toggleClass('productfilter__toggle--active');
        form.slideToggle();
    });

    var resize_check = function(){

        var browser_width = window.innerWidth;
        var toggle = $('.productfilter__toggle');

        if(browser_width >= 992){
            $('.productfilter__form').css({"display": "block"});
        }else{
            $('.productfilter__form').css({"display": "none"});
        }
    };

    $(window).on('resize', function(){
        resize_check();
    });

});


/* checkbox */
$(function(){
    var form_checkbox = $('.formfield--checkbox').find('input');
    form_checkbox.click(function(){
        if($(this).is(':checked')){
            $(this).parent().addClass('--checked');
        }else{
            $(this).parent().removeClass('--checked');
        }
    });
});
/* checkbox */



//scrollto
$(function(){
    $(".footer__scroll").click(function() {
        console.log('click');
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
        return false;
    });
});
